export class GenericError {
    constructor(translationKey, code) {
        this.name = 'GenericError';
        this.translationKey = translationKey;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            code: this.code,
            translationKey: this.translationKey,
        };
    }
    static fromJSON(json) {
        if (json.name !== 'GenericError') {
            throw new Error(`Invalid error type: expected 'GenericError', got '${json.name}'`);
        }
        return new GenericError(json.translationKey, json.code);
    }
}
